import Controller from "./controller";

let AvatarController = new Controller();

export {
    AvatarController
}
